import Logger from 'core/utils/Logger'

import { ActualsValueTypes } from '../../models/actualValueTypes'

/** One entry of PartnerData.ProgramOfferingsJson. */
export interface IProgramOfferingApi {
  Offering: string
  OfferingName: string
  ActualsValueTypeDefault?: string
  PDFActualsValueTypeDefault?: string
  ActualsValueTypes: string
}

export interface IProgramOffering {
  offering: string
  /** Human-readable name, e.g. Core Print or Personal Systems. */
  offeringName: string
  actualsValueTypeDefault?: ActualsValueTypes
  actualsValueTypes: ActualsValueTypes[]
}

export const ACTUALS_VALUE_TYPES_ORDER = [
  ActualsValueTypes.UTNet,
  ActualsValueTypes.TNet,
  ActualsValueTypes.Net,
  ActualsValueTypes.Ndp,
]

export const mapProgramOfferingFromApi = (data: IProgramOfferingApi): IProgramOffering => ({
  offering: data.Offering,
  offeringName: data.OfferingName,
  actualsValueTypeDefault: (data.ActualsValueTypeDefault ||
    data.PDFActualsValueTypeDefault ||
    ActualsValueTypes.None) as ActualsValueTypes,
  actualsValueTypes: (data.ActualsValueTypes || '')
    .split(',')
    .filter(Boolean) as ActualsValueTypes[],
})

export const parseProgramOfferingsJson = (jsonString?: string | null): IProgramOffering[] => {
  try {
    return (JSON.parse(jsonString ?? '[]') as IProgramOfferingApi[]).map(mapProgramOfferingFromApi)
  } catch (error) {
    Logger.error(`ProgramOfferingsJson: ${error}`)
    return []
  }
}

/** Resolve either the offering code or its name; Overall uses the union in control order. */
export const getOfferingActualsValueTypes = (
  offerings: readonly IProgramOffering[],
  selectedOffering?: string | null
): ActualsValueTypes[] => {
  const offering = selectedOffering
    ? offerings.find(
        (item) => item.offering === selectedOffering || item.offeringName === selectedOffering
      )
    : undefined
  if (offering) return [...offering.actualsValueTypes]

  const union = new Set(offerings.flatMap((item) => item.actualsValueTypes))
  return ACTUALS_VALUE_TYPES_ORDER.filter((type) => union.has(type))
}
